import { render, staticRenderFns } from "./goodsFlowSaleStat.vue?vue&type=template&id=5c073a18&"
import script from "./goodsFlowSaleStat.vue?vue&type=script&lang=js&"
export * from "./goodsFlowSaleStat.vue?vue&type=script&lang=js&"
import style0 from "./goodsFlowSaleStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports